'use client';

import * as React from 'react';
import { P } from '@paypoteam/ui-components';
import parse from 'html-react-parser';

import { ContentText } from '@/components/molecules/ContentText';
import { ItemsContainer } from '@/components/layout/ItemsContainer';
import Section from '@/components/layout/Section';

import ListItem from './components/ListItem';
import type { ImagesItemsSectionConfigType } from './ImagesItemsSection.types';

export interface ImagesItemsSectionProps
    extends React.HTMLAttributes<HTMLDivElement> {
    config: ImagesItemsSectionConfigType;
}

const ImagesItemsSection = React.forwardRef<
    HTMLDivElement,
    ImagesItemsSectionProps
>(({ config, className, ...props }, ref) => (
    <Section
        id={config.id || props.id}
        className={className}
        ref={ref}
        {...props}
    >
        <ContentText
            title={typeof config.title === 'string' ? config.title : undefined}
            textConfig={Array.isArray(config.title) ? config.title : undefined}
            className="heading-spaces text-center"
            data-test-id={
                config['data-test-id'] && `${config['data-test-id']}-title`
            }
        />

        <ItemsContainer
            gridOptions={{ columns: config.columns }}
            swiperOptions={{
                swiperProps: {
                    className: 'pb-4 md:!hidden',
                    sliderClassName: 'max-w-full',
                    pagination: true,
                    slidesPerView: 1,
                    // Added slider breakpoint to looking alike production
                    breakpoints: {
                        560: {
                            slidesPerView: 2,
                            spaceBetween: 16,
                        },
                    },
                },
                breakpoint: 'md',
            }}
            className={config.className}
            data-test-id={
                config['data-test-id'] && `${config['data-test-id']}-list`
            }
        >
            {config.list.map(elem => (
                <ListItem
                    key={elem.id}
                    {...elem}
                />
            ))}
        </ItemsContainer>

        {config.additionalText && (
            <P
                size="2xs"
                className="mt-8 text-typo-secondary"
            >
                {parse(config.additionalText)}
            </P>
        )}
    </Section>
));

export default ImagesItemsSection;
